import { useQuery } from "react-query";
import useRouteQuery from "../common/useRouteQuery";
import locationRepo from "../../API/LayoutApi/location.repo";

function useLocationList() {
  const [userId, setUserId] = useRouteQuery("", "user_id", (v) => String(v));
  const [page, setPage] = useRouteQuery(1, "page", (v) => Number(v));
  const [search, setSearch] = useRouteQuery("", "search", (v) => String(v));
  const [isActive, setIsActive] = useRouteQuery("", "is_active", (v) =>
    String(v)
  );

  const { isLoading, isFetching, data, refetch } = useQuery({
    queryKey: ["locations", page, userId, isActive],
    queryFn: () =>
      locationRepo.getLocations({
        page,
        perPage: 10,
        user_id: userId ? userId : undefined,
        search: search ? search : undefined,
        is_active: isActive ? JSON.parse(isActive) : undefined,
      }),
    refetchOnWindowFocus: false,
  });

  return {
    userId,
    setUserId,
    page,
    setPage,
    search,
    setSearch,
    isActive,
    setIsActive,
    isLoading,
    isFetching,
    data,
    refetch,
  };
}

export default useLocationList;
